import { jsx as _jsx } from "react/jsx-runtime";
import { useLottie } from "lottie-react";
import successAnimation from "./success-lottie.json";
const style = {
    height: 180,
    width: 180,
};
const SuccessAnimation = () => {
    const options = {
        animationData: successAnimation,
        loop: true,
        autoplay: true,
    };
    const Lottie = useLottie(options, style);
    return (_jsx("div", Object.assign({ style: {
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        } }, { children: Lottie.View })));
};
export default SuccessAnimation;
